import { BaseModel } from './base';

export class ContractCurrency extends BaseModel {
  CurrencyName: string;
  SubscriberId: string;
  SiteId: string;
  id: string;
  _id: string;
}
